const devApiUrl = 'http://localhost:3000/api'
const proApiUrl = 'http://api.youUrl.com'

const nodeDevEnv = process.env.NODE_ENV === 'development'

export default {
    version: '0.1.0',
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: 'element-layout',
    minSiteMame: 'EUI',
    apiPrefix: '',
    timeout: 5000,
    cookiesExpires: 7,
    requestRetry: 4,
    requestRetryDelay: 800,
    tokenKey: 'ACCESS_TOKEN',
    userInfoKey: 'USER_INFO',
    gitHub: 'https://gitee.com/yuandage/element-layout',
    storageType: 2, // 存储方式：1 = Cookies ；2 =  Storage
    obsAccessKeyId:'LLRXHY1JEL8AOTO0E85B',
    obsSecretAccessKey:'rhLaP0IHNh46cwDV0xN2FnKaXJtKOJQ2fMQ6XH63',
    obsServer:"https://obs.cn-north-4.myhuaweicloud.com",
    obsBucket:"water-a8a1",
    obsBaseUrl:"https://water-a8a1.obs.cn-north-4.myhuaweicloud.com/",

}

